import React from 'react';
import PropTypes from 'prop-types';
import { CreditCardIcon } from '@paypalcorp/pp-react';
import { Button } from '@paypalcorp/pp-react-buttons';
import classNames from 'classnames';

const OmniPrompt = function (props) {
  const {
    intentLabel,
    onClickHandler,
    totalIntentsLength,
    // eslint-disable-next-line no-unused-vars
    intentCardIcon,
  } = props;

  const intentCardClass = (length) =>
    classNames({
      'ocp--one': length === 1,
      'ocp--two': length === 2,
      'ocp--three': length === 3,
    });
  const handleKeyPress = (event) => {
    event.stopPropagation();
    if (event.key === 'Enter') {
      onClickHandler(event);
    }
  };
  return (
    <div className={intentCardClass(totalIntentsLength)}>
      <Button
        inverse
        className="ocp-button"
        iconComponent={CreditCardIcon}
        onClick={(e) => onClickHandler(e)}
        onKeyPress={(e) => handleKeyPress(e)}
      >
        {intentLabel}
      </Button>
    </div>
  );
};

OmniPrompt.propTypes = {
  intentLabel: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func.isRequired,
  totalIntentsLength: PropTypes.string.isRequired,
  intentCardIcon: PropTypes.string.isRequired,
};

export default OmniPrompt;
